import { TextField, TextFieldProps } from "@mui/material";
import { Autocomplete, InputAdornment, Box } from "@mui/material";

type MuiInputProp = {
  label?: string;
  placeholder?: string;
  isInvalid?: boolean;
  errorText?: string;
  isRequired?: boolean;
  disabled?: boolean;
  iconStart?: React.ReactNode;
  iconEnd?: React.ReactNode;
  onChange?: (value: string) => void;
} & Omit<TextFieldProps, "onChange">; // Omit MUI's default onChange to enforce custom typing

export const MuiInput = ({
  label,
  placeholder = "",
  errorText = "",
  isInvalid = false,
  isRequired = false,
  disabled = false,
  iconStart,
  iconEnd,
  onChange,
  ...rest
}: MuiInputProp) => {
  // Add asterisk to placeholder if isRequired is true
  const updatedPlaceholder =
    isRequired && placeholder ? `${placeholder} *` : placeholder;

  // Render label with red asterisk if isRequired
  const renderLabel =
    isRequired && label ? (
      <span>
        {label}
        <span style={{ color: "red" }}> *</span>
      </span>
    ) : (
      label
    );

  return (
    <TextField
      fullWidth
      label={renderLabel}
      error={isInvalid}
      helperText={isInvalid ? errorText : ""}
      placeholder={updatedPlaceholder}
      onChange={(e) => onChange?.(e.target.value)}
      disabled={disabled}
      {...rest}
      InputProps={{
        startAdornment: iconStart ? (
          <InputAdornment position="start">{iconStart}</InputAdornment>
        ) : null,
        endAdornment: iconEnd ? (
          <InputAdornment position="end">{iconEnd}</InputAdornment>
        ) : undefined,
      }}
    />
  );
};
